import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { CompanyType } from '../../core/brand/company-type.enum';
import { enumValidator } from '../../core/form/enum.validator';

export function companyTypeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validateEnum = enumValidator(CompanyType);
    const result = validateEnum(control);
    return result === null ? null : { companyType: true };
  };
}
